import { IController } from 'angular';
import { DateHelpers } from '../../../../../../ng2/shared/services/date-helpers/date-helpers.service';

import * as _ from 'lodash';
import { NextRegentsAdminDate } from '../../../../../../ng2/shared/constants/next-regents-admin-date.constant';
import { PlannedDiplomaType } from '../../../../../../ng2/shared/constants/planned-diploma-type.constant';
import { RegentsCategory } from '../../../../../../ng2/shared/constants/regents.constant';
import { ImStudent } from '../../../../../../ng2/shared/services/im-models/im-student.service';
import { ImStudentRegents } from '../../../../../shared/static-models/im-models/im-student-regents';

interface IFilteredScheduledNextAdminAndFutureExams {
  nextAdmin: any[];
  futureAdmin: any[];
}
interface IExamCatBox {
  examCat?: string;
  humanName?: string;
  maxScore?: number;
  scheduledExams?: any[];
  scheduled?: boolean;
  filteredScheduledNextAdminAndFutureExams?: IFilteredScheduledNextAdminAndFutureExams;
  isCatNeeded?: boolean;
  regentsName?: string;
  isFulfilled?: boolean;
  status?: string;
  isFulfilledCr?: boolean;
  order?: number;
  hasCollegeReadiness?: false;
  isRequired?: boolean;
  passedButCannotBeScheduledForCr?: boolean;
  cssClass?: string;
}

export class StudentRegentsPanelBoxesCtrl implements IController {
  static $inject = ['ImStudent', 'ImStudentRegents', 'DateHelpers', '$scope'];

  // bindings
  private student;
  private examsWithNoPlan;

  // local
  private NextRegentsAdminDate;
  private NextRegentsAdminDateUpper;
  private plannedDiplomaType;
  private boxesAreByCat5Or9;
  private plannedDiplomaTypeDetails;
  private keyForFulfilled;
  private examCatBoxes;
  private filteredByCat5ExamBoxes;

  constructor(
    private ImStudent: ImStudent,
    private ImStudentRegents: ImStudentRegents,
    private DateHelpers: DateHelpers,
    private $scope,
  ) {}

  $onInit() {
    this.NextRegentsAdminDate = this._getNextRegentsAdminDate();
    this.NextRegentsAdminDateUpper = this.NextRegentsAdminDate.toUpperCase();
    this.plannedDiplomaType = this.student.gradPlanningDetails.plannedDiplomaType;

    this._updateCtrlOnChange();

    // watch change for plannedDiplomaType and isSafetyNetEligible (both are in gradPlanningDetails)
    this.$scope.$watch(
      () => {
        return this.student.gradPlanningDetails;
      },
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          // prevent $watch triggered on init
          this._updateCtrlOnChange();
        }
      },
      true,
    );

    // watch change for nextScheduledRegents
    this.$scope.$watch(
      () => {
        return this.student.nextScheduledRegents;
      },
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          // prevent $watch triggered on init
          this._updateCtrlOnChange();
        }
      },
      true,
    );
  }

  // this function allows us to stub out te next regents admin date for tests.
  _getNextRegentsAdminDate() {
    return NextRegentsAdminDate;
  }

  _updateCtrlOnChange() {
    // fn invokation must be in order
    this._setSharedVars();
    this._setExamCatBoxes();
    this._setExamsWithNoPlanCount();
    this.boxesAreByCat5Or9 = this.ImStudent.isPlannedDiplomaTypeByCat5OrByCat9(this.student);
    this._setfilteredByCat5ExamBoxes(this.examCatBoxes, this.boxesAreByCat5Or9);
  }

  _setSharedVars() {
    this.plannedDiplomaTypeDetails = _.find(PlannedDiplomaType, {
      humanName: this.student.gradPlanningDetails.plannedDiplomaType,
    });
    this.keyForFulfilled = this.ImStudentRegents.getRegentsFulfilledKeyBasedOnDiplomaType(
      this.student,
      this.plannedDiplomaTypeDetails,
    );
  }

  _setExamsWithNoPlanCount() {
    this.examsWithNoPlan.count = _.filter(this.examCatBoxes, { cssClass: 'red' }).length;
  }

  _setfilteredByCat5ExamBoxes(examBoxes, byCat) {
    if (byCat === '5') {
      // do not show LOTE
      this.filteredByCat5ExamBoxes = {
        required: _.take(examBoxes, 4),
        plus1: examBoxes[4],
      };
    }
  }

  // used for summary box
  _getTotalsForCurrDiplomaType() {
    const onTrackStatus = this.ImStudentRegents.getRegentsOnTrackStatus(this.student, this.plannedDiplomaType);
    const { totalRequiredCategories, totalRequiredCategoriesFulfilled, neededOnTrackCategories } = onTrackStatus;
    const currDiplomaTypeTotals = {
      totalCats: totalRequiredCategories,
      totalFulfilledCats: totalRequiredCategoriesFulfilled,
      totalNeededCatsToBeOnTrack: neededOnTrackCategories.length,
    };

    return currDiplomaTypeTotals;
  }

  // used for summary box
  _getTotalsForDiffDiplomaTypes() {
    const onTrackStatuses = this.ImStudentRegents.getRegentsOnTrackStatusForDiffDiplomaTypes(this.student);
    const { advanced, regents, local } = onTrackStatuses;
    const {
      totalRequiredCategories: totalRequiredCategoriesAdv,
      totalRequiredCategoriesFulfilled: totalRequiredCategoriesFulfilledAdv,
    } = advanced;
    const {
      totalRequiredCategories: totalRequiredCategoriesReg,
      totalRequiredCategoriesFulfilled: totalRequiredCategoriesFulfilledReg,
    } = regents;
    const {
      totalRequiredCategories: totalRequiredCategoriesLoc,
      totalRequiredCategoriesFulfilled: totalRequiredCategoriesFulfilledLoc,
    } = local;
    const diffDiplomaTypesTotals = {
      advanced: {
        totalCats: totalRequiredCategoriesAdv,
        totalFulfilledCats: totalRequiredCategoriesFulfilledAdv,
      },
      regents: {
        totalCats: totalRequiredCategoriesReg,
        totalFulfilledCats: totalRequiredCategoriesFulfilledReg,
      },
      local: {
        totalCats: totalRequiredCategoriesLoc,
        totalFulfilledCats: totalRequiredCategoriesFulfilledLoc,
      },
    };

    return diffDiplomaTypesTotals;
  }

  _getSummaryBox() {
    const current = this._getTotalsForCurrDiplomaType();
    const diff = this._getTotalsForDiffDiplomaTypes();
    const { advanced, local, regents } = diff;
    const cssClass = 'overall-box';

    return {
      advanced,
      cssClass,
      current,
      local,
      regents,
    };
  }

  _setExamCatBoxes = function() {
    const ignoreSecondAndThirdCats = true;
    const plannedDiplomaType = null;
    // tslint:disable-next-line:max-line-length
    const regentsCatsBasedOnDiplomaType = this.ImStudentRegents.getRegentsCatsBasedOnDiplomaType(
      this.student,
      plannedDiplomaType,
      ignoreSecondAndThirdCats,
    );
    const regentsCatsToShow = _.reduce(
      regentsCatsBasedOnDiplomaType,
      (acc, regentsCat, regentsCatKey) => {
        const regentsCatConstant = _.find(RegentsCategory, { key: regentsCatKey });
        const { showBox } = regentsCatConstant;
        if (showBox) {
          acc.studentRegentsCats[regentsCatKey] = regentsCat;
          acc.regentsCatsConstantsHash[regentsCatKey] = regentsCatConstant;
        }
        return acc;
      },
      { studentRegentsCats: {}, regentsCatsConstantsHash: {} },
    );
    const { studentRegentsCats, regentsCatsConstantsHash } = regentsCatsToShow;

    // box creation
    this.examCatBoxes = _.sortBy(
      _.map(studentRegentsCats, (regentsCat, regentsCatKey) => {
        const regentsCatsConstant = regentsCatsConstantsHash[regentsCatKey];

        return this.generateExamCatBox.call(this, regentsCat, regentsCatKey, regentsCatsConstant);
      }),
      examCatBox => {
        return examCatBox.order;
      },
    );

    // summary box
    this.overallBox = this._getSummaryBox();
  };

  generateExamCatBox(examCatDetails, examCat, regentsCategory): IExamCatBox {
    const examCatBox: IExamCatBox = {};
    examCatBox.examCat = examCat;
    examCatBox.humanName = regentsCategory.humanName;
    examCatBox.maxScore = parseInt(examCatDetails.maxScore.string) || examCatDetails.maxScore.string;
    examCatBox.scheduledExams = getExamsScheduledForCat.call(this, examCat);
    examCatBox.scheduled = !!examCatBox.scheduledExams.length;
    examCatBox.filteredScheduledNextAdminAndFutureExams = filterScheduledNextAdminAndFutureExams.call(
      this,
      this.keyForFulfilled,
      examCatBox.scheduledExams,
    );
    examCatBox.isCatNeeded = this.ImStudentRegents.isRegentsCatNeededForOnTrack(this.student, examCatBox.examCat);
    examCatBox.regentsName = examCatDetails.regentsName;
    examCatBox.isFulfilled = examCatDetails[this.keyForFulfilled];
    examCatBox.status = _getStatusForCat.call(this, examCatBox.isCatNeeded);
    examCatBox.isFulfilledCr = examCatBox.isFulfilled && examCatDetails.fulfilledCr;
    examCatBox.order = regentsCategory.order;
    examCatBox.hasCollegeReadiness = regentsCategory.hasCollegeReadiness;
    examCatBox.isRequired = this.ImStudentRegents.isRegentsCatRequiredForDiplomaType(
      this.student,
      examCat,
      this.plannedDiplomaType,
    );

    examCatBox.passedButCannotBeScheduledForCr =
      examCatBox.isFulfilled &&
      isSafetyNetEligibleStudentAndHasScoreOf55to65ForElaOrMathCat.call(this, examCatBox.maxScore);
    examCatBox.cssClass = getCssClass(examCatBox);

    return examCatBox;

    function getCssClass(examCatStatus) {
      if (examCatStatus.status === 'N/A') {
        return 'gray hide-sched';
      }

      // For studentYear === 0 (D75, MS)
      if (examCatStatus.status === 'NOT NEEDED') return 'default';

      if (examCatBox.status === 'Potentially Comp') {
        return 'orange';
      }

      // For Fulfilled Cats
      if (examCatStatus.isFulfilledCr) {
        return examCatStatus.scheduled ? 'blue' : 'blue hide-sched';
      }

      if (examCatStatus.isFulfilled) {
        if (examCatStatus.hasCollegeReadiness && !examCatStatus.passedButCannotBeScheduledForCr) {
          return examCatStatus.scheduled ? 'lightblue' : 'green hide-sched';
        }
        return examCatStatus.scheduled ? 'green' : 'green hide-sched';
      }

      // For Non-Fulfilled Cats with Sched Exams
      if (examCatStatus.scheduled) {
        return 'lightgreen';
      }

      // For  Non-Fulfilled Cats with NO Sched Exams
      if (examCatStatus.isCatNeeded) {
        return 'red';
      }

      if (!examCatStatus.isRequired) {
        return 'gray hide-sched';
      }

      return 'default hide-sched';
    }

    /**
     * Method only applies to safety net eligible students and ELA and Math categories
     * It will return true if a student is sped and the max score of the exam is between 55 to 65
     * For any other categories, it will return false
     * @param {Object} student - instance of a student
     * @returns {Boolean}
     */
    function isSafetyNetEligibleStudentAndHasScoreOf55to65ForElaOrMathCat(maxScore) {
      const regentsCategoriesWithSpedRangeOf55to65 = [
        RegentsCategory.ELA.key,
        RegentsCategory.MATH.key,
        RegentsCategory.ALGEBRA.key,
        RegentsCategory.GEOMETRY.key,
        RegentsCategory.TRIGONOMETRY.key,
      ];

      if (this.ImStudent.isSafetyNetEligible(this.student)) {
        if (_.includes(regentsCategoriesWithSpedRangeOf55to65, examCat)) {
          if (maxScore >= 55 && maxScore < 65) {
            return true;
          }
        }
      }
      return false;
    }

    function _getStatusForCat(isCatNeeded) {
      const status = this.ImStudentRegents.getStatusForRegentsCat(this.student, examCat, this.plannedDiplomaType);
      if (status === 'N/A') {
        return 'N/A';
      } else if (status === 'Not Passed') {
        if (isCatNeeded) {
          return 'NEEDED';
        }
        return 'NOT MET';
      } else if (status === 'NOT NEEDED') return status;
      return status;
    }

    function getExamsScheduledForCat(examCat) {
      const regentsCategoryKey = examCat;
      const adminDate = null;
      // for non college-ready by cat 5 categories, we do not want ignore second and third categories
      const ignoreSecondAndThirdCats =
        examCat === RegentsCategory.SOCIAL_STUDIES.key || examCat === RegentsCategory.SCIENCE.key;
      // tslint:disable-next-line:max-line-length

      // plus1
      const regentsExamsScheduledForRegentsCat = this.ImStudentRegents.getRegentsExamsScheduledForRegentsCat(
        this.student,
        regentsCategoryKey,
        adminDate,
        ignoreSecondAndThirdCats,
      );

      const examsScheduledForCat = _.sortBy(
        _.map(regentsExamsScheduledForRegentsCat, (exam: any) => {
          const { category } = exam;
          const byCat5Key = category[5].key;

          return {
            byCat5Key,
            humanName: exam.humanName,
            adminDate: this.student.nextScheduledRegents[exam.key].adminDate,
          };
        }),
        exam => {
          const date = this.DateHelpers.getMomentObjForMonthYearDate(exam.adminDate).toDate();

          return date;
        },
      );

      return examsScheduledForCat;
    }

    function filterScheduledNextAdminAndFutureExams(keyForFulfilled, scheduledExams) {
      let nextAdmin = [];
      let futureAdmin = [];

      if (examCat === 'plus1') {
        const scheduledExamsByCat = _.reduce(
          scheduledExams,
          (acc, exam: any) => {
            const { byCat5Key, adminDate } = exam;

            if (!acc[byCat5Key]) acc[byCat5Key] = { next: [], future: [] };

            const { next, future } = acc[byCat5Key];

            if (adminDate === this.NextRegentsAdminDate) next.push(exam);
            else future.push(exam);

            return acc;
          },
          {},
        );

        _.each(scheduledExamsByCat, (cat: any, catKey) => {
          const { next, future } = cat;
          const catFulfilled = this.student.regentsDetails.byCategory5[catKey][keyForFulfilled];

          if (catFulfilled) {
            nextAdmin = [...nextAdmin, ...next];
            futureAdmin = [...futureAdmin, ...future];
          } else {
            if (next.length > 1) nextAdmin = [...nextAdmin, ...next];
            else if (future.length) futureAdmin = [...futureAdmin, ...future];
          }
        });
      } else {
        _.each(scheduledExams, (exam: any) => {
          if (exam.adminDate === this.NextRegentsAdminDate) return nextAdmin.push(exam);
          return futureAdmin.push(exam);
        });
      }

      return {
        nextAdmin,
        futureAdmin,
      };
    }
  }
}
angular.module('nv.singleStudent').controller('StudentRegentsPanelBoxesCtrl', StudentRegentsPanelBoxesCtrl);
